import { DriverDocumentStatusEnum } from 'common/document/enums/driver-document-status.enum';
import { DocumentTypeEnum } from 'common/document/enums/document-type.enum';
import { EndorsementEnum } from '../enums/endorsement.enum';
import { RestrictionEnum } from '../enums/restriction.enum';
import { DriverLicenseTypeEnum } from '../enums/driver-license-type.enum';

export interface IDriverDocumentRequested {
  type: DocumentTypeEnum;
  title: string;
  expires: Date;
  status: DriverDocumentStatusEnum;
  reason: string;
}

export interface IDriverDocumentImagesReview {
  label: string;
  src: string;
}

export interface IDriverDocumentReview {
  id: string;
  documentType: DocumentTypeEnum;
  title: string;
  approved: boolean;
  rejected: boolean;
  reason: string;
  data: IDriverCdlFields | IDOTMedicalCardFields;
  images: IDriverDocumentImagesReview[];
  details?: any[];
  documentFiles?: any[];
  documentName?: string;
  status?: string;
}

export interface IDriverCdlFields {
  driversLicenseNumber: string;
  firstName: string;
  lastName: string;
  dateOfBirth?: Date | undefined;
  driverClass: DriverLicenseTypeEnum;
  issuingState: string;
  issueDate?: Date | undefined;
  expireDate?: Date | undefined;
  restrictions: RestrictionEnum[];
  endorsements: EndorsementEnum[];
  country: string;
}

export const driverCdlDefault: IDriverCdlFields = {
  driversLicenseNumber: '',
  firstName: '',
  lastName: '',
  dateOfBirth: undefined,
  driverClass: DriverLicenseTypeEnum.NON_CDL,
  issuingState: '',
  issueDate: undefined,
  expireDate: undefined,
  restrictions: [],
  endorsements: [],
  country: '',
};

export const driverCdlDefaultVerification = {
  driversLicenseNumber: false,
  firstName: false,
  lastName: false,
  dateOfBirth: false,
  driverClass: false,
  issuingState: false,
  issueDate: false,
  expireDate: false,
  restrictions: false,
  endorsements: false,
  country: false,
};

export const driverCdlDefaultPolygon = {
  driversLicenseNumber: null,
  firstName: null,
  lastName: null,
  dateOfBirth: null,
  driverClass: null,
  issuingState: null,
  issueDate: null,
  expireDate: null,
  restrictions: null,
  endorsements: null,
  country: null,
};

export interface IDOTMedicalCardFields {
  examinerLicenseNumber: string;
  expirationDate?: Date | undefined;
  driversLicenseNumber: string;
  medicalExaminerName: string;

  wearingCorrectiveLenses?: undefined;
  wearingHearingAid?: undefined;
  accompaniedSPESertificate?: undefined;
  drivingWithExempIntracityZone?: undefined;
  grandfatherdStateRequirements?: undefined;
  qualified49CFR39163?: undefined;
  medExaminerPhone?: undefined;
  accompaniedByText?: undefined;
  qualifiedInAccordanceWith49CFR39164?: undefined;
  accompaniedByWaiverOrExemption?: undefined;
  qualifiedInAccordanceWith49CFR39164WithApplicableStateVariances?: undefined;
  issueDate?: Date;
}

export const dotMedicalCardDefault: IDOTMedicalCardFields = {
  examinerLicenseNumber: '',
  expirationDate: undefined,
  driversLicenseNumber: '',
  medicalExaminerName: '',

  wearingCorrectiveLenses: undefined,
  wearingHearingAid: undefined,
  accompaniedSPESertificate: undefined,
  drivingWithExempIntracityZone: undefined,
  grandfatherdStateRequirements: undefined,
  qualified49CFR39163: undefined,
  medExaminerPhone: undefined,
  accompaniedByText: undefined,
  accompaniedByWaiverOrExemption: undefined,
  qualifiedInAccordanceWith49CFR39164: undefined,
  qualifiedInAccordanceWith49CFR39164WithApplicableStateVariances: undefined,
};

export const dotMedicalCardDefaultVerification = {
  examinerLicenseNumber: false,
  expirationDate: false,
  driversLicenseNumber: false,
  medicalExaminerName: false,
};

export const dotMedicalCardDefaultPolygon = {
  examinerLicenseNumber: null,
  expirationDate: null,
  driversLicenseNumber: null,
  medicalExaminerName: null,
};

export interface IDriverChecklistFields {
  driverName: string;
  alphaCode: string;
  drugOrAlcohol: boolean;
  drugOrAlcoholExplanation?: string;
  amphetamines: boolean;
  amphetaminesExplanation?: string;
  opiates: boolean;
  opiatesExplanation?: string;
  marijuana: boolean;
  marijuanaExplanation?: string;
  cocaine: boolean;
  cocaineExplanation?: string;
  pcp: boolean;
  pcpExplanation?: string;
  otherDrugs: boolean;
  otherDrugsExplanation?: string;
  hearing: boolean;
  hearingIsCurrent?: boolean;
  skillPerformanceEvaluation: boolean;
  skillPerformanceEvaluationIsCurrent?: boolean;
  alternativeVisionStandard: boolean;
  alternativeVisionStandardIsCurrent?: boolean;
}

export const driverChecklistDefault: IDriverChecklistFields = {
  driverName: '',
  alphaCode: '',
  drugOrAlcohol: false,
  drugOrAlcoholExplanation: '',
  amphetamines: false,
  amphetaminesExplanation: '',
  opiates: false,
  opiatesExplanation: '',
  marijuana: false,
  marijuanaExplanation: '',
  cocaine: false,
  cocaineExplanation: '',
  pcp: false,
  pcpExplanation: '',
  otherDrugs: false,
  otherDrugsExplanation: '',
  hearing: false,
  hearingIsCurrent: false,
  skillPerformanceEvaluation: false,
  skillPerformanceEvaluationIsCurrent: false,
  alternativeVisionStandard: false,
  alternativeVisionStandardIsCurrent: false,
};

export const driverChecklistDefaultVerification = {
  driverName: true,
  alphaCode: true,
};
